import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";

const PricingPolicy = () => {
  
//   useEffect(() => {
//     AOS.init({ duration: 1000 });
//   }, []);

  return (
    <main className="bg-gray-50 min-h-screen mt-20 px-5 py-10">
      <section id="refund-policy" className="refund-policy">
        <div className="container mx-auto">
          <div className="text-center" data-aos="fade-up">
            <h2 className="text-4xl font-bold mb-5">Pricing Policy</h2>
            <p className="text-gray-600">
              <strong>Effective Date:</strong> 28/06/2024
            </p>
          </div>

          <div className="mt-10">
            <p className="mb-5">
              Welcome to Cruze, a platform designed to provide seamless travel
              experiences and ticket booking services. Below is our pricing
              policy, outlining how fares are determined and billed for both
              cab rides and ticket purchases.
            </p>

            <ol className="list-decimal list-inside space-y-8">
              {/* Fare Calculation */}
              <li>
                <h3 className="text-2xl font-semibold">Fare Calculation</h3>
                <p className="mt-2">
                  <strong>Cab Rides:</strong><br />
                  At Cruze, your trip fare is determined through a bidding process
                  where drivers submit offers. You, the rider, choose the bid that
                  best suits your needs. The fare displayed in the app is the
                  amount you will pay for the trip. Currently, Cruze does not
                  charge additional platform fees or GST. The full amount paid by
                  you is passed directly to the driver.
                </p>
              </li>

              {/* Additional Fees */}
              <li>
                <h3 className="text-2xl font-semibold">Additional Fees</h3>
                <p className="mt-2">
                  <strong>Cab Rides:</strong><br />
                  <em>Platform Fee:</em> Cruze does not charge any additional
                  platform fees for using our service. However, Goods and Services
                  Tax (GST) is applicable to fares.
                </p>
              </li>

              {/* Payment Method */}
              <li>
                <h3 className="text-2xl font-semibold">Payment Method</h3>
                <p className="mt-2">
                  All payments for trips and tickets booked through Cruze must be
                  made via the payment methods available in the app. After
                  completing the trip or ticket purchase, the fare or ticket
                  amount will be charged to your selected payment method.
                </p>
              </li>

              {/* Fare and Ticket Transparency */}
              <li>
                <h3 className="text-2xl font-semibold">Fare and Ticket Transparency</h3>
                <p className="mt-2">
                  We are committed to providing transparent pricing:<br />
                  <strong>Cab Rides:</strong> The fare displayed in the app
                  includes all applicable charges determined through the driver
                  bidding process.
                </p>
              </li>

              {/* Policy Updates */}
              <li>
                <h3 className="text-2xl font-semibold">Policy Updates</h3>
                <p className="mt-2">
                  Cruze reserves the right to modify this pricing policy at any
                  time. Changes will be communicated to users through the app and
                  will be effective immediately upon posting. It is your
                  responsibility to review the policy periodically for updates.
                </p>
              </li>

              {/* Contact Information */}
              <li>
                <h3 className="text-2xl font-semibold">Contact Information</h3>
                <p className="mt-2">
                  For questions or concerns regarding our pricing policy, contact
                  our support team at{" "}
                  <a
                    href="mailto:admin@cruze.asia"
                    className="text-blue-600 hover:underline"
                  >
                    admin@cruze.asia
                  </a>.
                </p>
              </li>
            </ol>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PricingPolicy;
